import AddCustomer from '../../pages/Customer/AddCustomer';
import { CustomerController } from '../../controllers';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import { MimaToastUtil } from '../../components';
import { phoneRegExp } from '../../utils/utils';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';
import { userStore } from '../../stores';

const AddCustomerContainer = ({ closeModal, goBack, setShowSurvey }) => {

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.CUSTOMERCREATE);

	const [loading, setLoading] = useState(false);

	const customerDetailsValidation = () => {
		return yup.object({
			fullname: yup.string().required('Customer name is required'),
			mobile: yup.string()
				.matches(phoneRegExp, 'Phone number is not valid')
				.required('Customer phone number is required'),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);
		for (const key in payload) {
			if (payload[key] === '') {
				delete payload[key];
			}
		}

		delete payload.customerGroupName;

		const { status, errorMessage } = await CustomerController.createCustomer(
			payload
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			closeModal();
			if (needFeedback._id) {
				setShowSurvey(true)
				userStore.setReviewId(needFeedback._id)
			}
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<AddCustomer
			closeModal={closeModal}
			loading={loading}
			onSubmit={onSubmit}
			customerDetailsValidation={customerDetailsValidation}
			goBack={goBack}
		/>
	);
};

export default observer(AddCustomerContainer);
